import type { CCThemeColors } from "@/modules/careerCenter/types"
import type { FunctionComponent, PropsWithChildren } from "react"

import { hasCustomTheme } from "@/modules/careerCenter/hasCustomTheme"
import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"

const cssVariableNames: Record<keyof CCThemeColors, string> = {
  boxTitleColor: "themeBoxTitleColor",
  buttonTextColor: "themeButtonTextColor",
  headerColor: "themeHeaderColor",
  headerTextColor: "themeHeaderTextColor",
  mainColor: "themeMainColor",
  mainDarkenColor: "themeMainDarkenColor",
  mainTextColor: "themeMainTextColor",
}

export const CCTheme: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { dataCareerCenter } = useCareerCenterFetch()

  return (
    <>
      {hasCustomTheme(dataCareerCenter?.careerCenterConf.theme) && (
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `
              :root {
                ${Object.entries(dataCareerCenter?.careerCenterConf.theme || {})
                  .map(
                    ([cssVarName, cssValue]) =>
                      cssValue && `--${cssVariableNames[cssVarName as keyof CCThemeColors]}: ${cssValue}`
                  )
                  .filter(Boolean)
                  .join(";\n")}
              }
            `,
          }}
        />
      )}
      {children}
    </>
  )
}
